import {
  WishlistSnackbar as WishlistSnackbarComponent,
  wishlistSnackbarActions,
} from "halifax";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { wishlistsApi } from "@capone/common";
import { WishlistWithMetadata } from "@b2bportal/travel-wishlists-api";

export const WishlistSnackbar = () => {
  const dispatch = useDispatch();

  const {
    isOpen,
    snackbarType,
    wishlistId,
    listingId,
    listingImageUrl,
    stayType,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } = useSelector((state: any) => state.wishlistSnackbar);

  const wishlist = useSelector(
    wishlistsApi.endpoints.getAllWishlists.select()
    // eslint-disable-next-line no-shadow
  )?.data?.wishlists?.find((wishlist) => wishlist.id.value === wishlistId);

  const closeSnackbar = () => dispatch(wishlistSnackbarActions.closeSnackbar());

  return (
    <WishlistSnackbarComponent
      isOpen={isOpen}
      snackbarType={snackbarType}
      listingId={listingId}
      listingImageUrl={listingImageUrl}
      stayType={stayType}
      wishlist={wishlist as WishlistWithMetadata}
      onClose={closeSnackbar}
    />
  );
};
